export const getValpolicellaData = () => ({
  name: "Valpolicella",
  country: "Italie",
  region: "Vénétie",
  description: "Valpolicella est une appellation prestigieuse de la Vénétie, produisant des vins rouges élégants et des Amarone complexes avec le cépage Corvina.",
  type: "subregion",
  mapAreas: [
    { region: "Valpolicella", x: 50, y: 45, color: "#4B164C", size: 5 }
  ],
  statistics: {
    totalArea: "7,500 ha",
    production: "250,000 hl",
    wineries: "300+ domaines",
    villages: "5 communes historiques",
    exportPercentage: "70%"
  },
  characteristics: {
    climate: "Climat continental tempéré, étés chauds, hivers froids",
    soil: "Sols calcaires et argilo-calcaires, moraines",
    viticulture: "Vendanges manuelles, pergolas traditionnelles, appassimento"
  },
  wineStyles: {
    red: "Rouges élégants et fruités, Amarone puissants et complexes"
  },
  history: "Valpolicella produit des vins depuis l'Antiquité romaine. L'Amarone est né au XVIe siècle de la technique d'appassimento.",
  foodPairing: "Viandes rouges, gibier, fromages affinés, risotto, Amarone avec desserts",
  grapeVarieties: [
    {
      name: "Corvina",
      percentage: "60%",
      description: "Cépage roi de Valpolicella, produisant des vins élégants et aromatiques",
      characteristics: "Élégant, aromatique, tanins soyeux, notes de cerise",
      wineStyles: "Sec, moyen-corps, aromatique"
    },
    {
      name: "Rondinella",
      percentage: "25%",
      description: "Cépage d'assemblage, apportant structure et couleur",
      characteristics: "Structuré, coloré, tanins fermes, notes de fruits noirs",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Molinara",
      percentage: "10%",
      description: "Cépage d'assemblage, apportant acidité et fraîcheur",
      characteristics: "Acidité vive, fraîcheur, notes d'agrumes",
      wineStyles: "Sec, léger, frais"
    },
    {
      name: "Corvinone",
      percentage: "5%",
      description: "Cépage d'assemblage, apportant complexité",
      characteristics: "Complexe, notes d'épices, structure équilibrée",
      wineStyles: "Sec, moyen-corps, complexe"
    }
  ]
}); 